// filepath: c:\devops\hobbies\taraxa\validator-frontend\app\src\config\networkConfig.ts
export const customNetwork = {
    chainId: '0x349', // 841 in hex
    chainName: 'Taraxa Mainnet',
    nativeCurrency: {
      name: 'TARA',
      symbol: 'TARA',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.mainnet.taraxa.io/'],
    blockExplorerUrls: ['https://explorer.mainnet.taraxa.io'],
  };
  
export const DPOS_CONTRACT_ADDRESS = "0x00000000000000000000000000000000000000fe";
export const TARGET_VALIDATOR = "0x70B7Ffd8269F116f7DF6A46EDd993263aBD3EEB0";
export const RPC_URL = "https://rpc.mainnet.taraxa.io/";